module.exports = __webpack_public_path__ + "static/media/trade.d15a072b.png";